import { render, staticRenderFns } from "./SurveyTab.vue?vue&type=template&id=22124808&scoped=true"
import script from "./SurveyTab.vue?vue&type=script&lang=js"
export * from "./SurveyTab.vue?vue&type=script&lang=js"
import style0 from "./SurveyTab.vue?vue&type=style&index=0&id=22124808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22124808",
  null
  
)

export default component.exports